//@ts-nocheck
import React, { useState } from "react";
import Rating from "react-rating";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { ReversedRatingBar } from "../../../Constant";
import { REVERSED_RATING } from "../../../Data/Bonus Ui/Rating";
import { P } from "../../../AbstractElements";

const ReverseRating = () => {
  const [rating, setRating] = useState(5);

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={ReversedRatingBar} span={REVERSED_RATING} />
        <CardBody>
          <Rating start={0} stop={10} initialRating={rating} onClick={handleRatingChange} direction="rtl"/>
          <P>Selected Rating: {rating}</P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ReverseRating;
